// If the child node is not an array of elements but an additional wrapper
// above them we should apply recursion to get inner wrapper element.
const getWrapperElement = (element) =>
  !element.childElementCount || element.childElementCount > 1
    ? element
    : getWrapperElement(element.firstChild);

const getOffsetParams = (carouselRef, activeIndex) => {
  const wrapperElement = getWrapperElement(carouselRef.current);

  let nextOffset = 0;
  // Calculate the sum of widths of slides preceding the current one.
  for (let i = 0; i < activeIndex; ++i) {
    nextOffset += wrapperElement.childNodes[i]
      ? +wrapperElement.childNodes[i].getBoundingClientRect().width.toFixed(2) + 8
      : 0;
  }

  const maxOffset = wrapperElement.scrollWidth - wrapperElement.offsetWidth;

  const offset = nextOffset > maxOffset ? maxOffset : nextOffset;

  return { offset, maxOffset };
};

export { getOffsetParams, getWrapperElement };
